import { observable, toJS, computed } from "mobx";
import Reviews from "../@libs/Reviews";
import ModalStore from "@src/stores/Component/ModalStore";

class ProfileReviewsListStore extends Reviews {
	reviewsFilter = { active: true };
	sort = { created_at: -1 };

	constructor(rootStore, staticContext) {
		super({
			rootStore: rootStore,
		});
		this.ModalStore = new ModalStore();
		this.reviewsFilter.provider = staticContext.provider
			? staticContext.provider._id
			: undefined;
	}

	get filter() {
		return this.reviewsFilter;
	}

	@observable _items = [];
	@computed
	get reviews() {
		return toJS(this._items);
	}

	@observable _count = 0;
	@computed
	get reviewsCount() {
		return toJS(this._count);
	}

	@observable _page = 1;
	@computed
	get page() {
		return toJS(this._page);
	}

	@observable _isLoading = false;
	@computed
	get isLoading() {
		return toJS(this._isLoading);
	}

	get show() {
		return this.ModalStore.show;
	}

	onClose(clearData) {
		this.ModalStore.onClose(clearData);
	}
}

export default ProfileReviewsListStore;
